import Routes from './Routes.jsx';
import Toast from './components/utils/Toast'
import { ToastProvider } from 'react-toast-notifications';

const App = () => {
  return (
    <div className="min-h-screen bg-primary text-white">
      <ToastProvider autoDismiss placement="bottom-right" components={{ Toast }}>
        <Routes />
      </ToastProvider>
    </div>
  );
}

export default App;
